// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items-container[data-v-f5d38b34]{max-height:300px;overflow:scroll}.item-container[data-v-f5d38b34]{padding:5px}.select-container[data-v-f5d38b34]{background-color:#f0f0f0;font-size:12px;padding:5px 15px 5px 15px;border-radius:5px;border:1px solid hsla(0,0%,100%,0)}.select-container[data-v-f5d38b34]:has(input:checked){border:1px solid #858585}.item-container label[data-v-f5d38b34]{margin:0}.gap[data-v-f5d38b34]{gap:1.25rem}", ""]);
// Exports
module.exports = exports;
